import React from 'react'
import * as yup from 'yup'
import { Badge } from '@softwaredev_cegeka/stix-core'

export function getStatusName(status) {
    return (
        status.charAt(0).toUpperCase() +
        status.slice(1).replace(/_/g, ' ').toLowerCase()
    )
}

export function formatDate(
    date,
    options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    }
) {
    if (!date) {
        return '-'
    }
    if (typeof date === 'string') {
        // Year month ex. 202009
        if (date.length === 6) {
            date = `${date.slice(0, 4)}-${date.slice(4, 6)}-01`
        }
        date = new Date(Date.parse(date))
    } else if (typeof date === 'number') {
        date = new Date(date * 1000)
    }
    return new Intl.DateTimeFormat('nl-BE', options).format(date)
}

/**
 * Get the value of a nested key inside an object by providing the path to it separated by dots
 *
 * @param {Object} obj
 * @param {String} path of the key for which you want to return the value. Example: customer.name
 */
export function leaf(obj, path) {
    return path.split('.').reduce((value, el) => value && value[el], obj)
}

/**
 * Generate the required data for [itemRenderer] prop of [AsyncSelect] component
 *
 * @param {Response} res network response
 * @param {String} firstLabel label of the select item
 * @returns {Object}
 */
export function asyncSelectItemsRenderer(
    res,
    firstLabel,
    secondLabel = '',
    separator = ''
) {
    return res.data.results.map(item => ({
        value: item.id,
        label:
            secondLabel === ''
                ? leaf(item, firstLabel)
                : `${leaf(item, firstLabel)} ${separator} ${leaf(
                      item,
                      secondLabel
                  )}`,
        ...item,
    }))
}

/**
 * Generated array of objects used in [Select] component, for every element
 * wrapping the label with a [Badge] component
 *
 * @param {Object} statusMap
 * @returns {Array<{id: String, value: String, label: React.Component}>}
 */
export function generateSelectStatuses(statusMap) {
    return Object.entries(statusMap).map(status => {
        return {
            value: status[0],
            label: (
                <Badge key={status[0]} size="tiny" variant={status[1]}>
                    {getStatusName(status[0])}
                </Badge>
            ),
        }
    })
}

/**
 * Generate one object used in [Select] component, wrapping the label with
 * a [Badge] component
 *
 * @param {String} status
 * @param {Object} statusMap
 */
export function generateSelectStatus(status, statusMap) {
    return {
        value: status,
        label: (
            <Badge size="tiny" variant={statusMap[status]}>
                {getStatusName(status)}
            </Badge>
        ),
    }
}

export function yupSelectRequired(message) {
    return yup
        .object()
        .shape({ value: yup.mixed().required(message) })
        .required(message)
        .typeError(message)
}

export function formatCostPrice(price) {
    // transforms from 1234.50 to 1.234,50
    if (price === null) return 'Cost on request'
    return parseFloat(price.toString().replace(',', '.')).toLocaleString(
        'de-DE',
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }
    )
}
